import ClickOutside from 'v-click-outside';
import Vue from 'vue';

Vue.use(ClickOutside);
